// extracted by mini-css-extract-plugin
module.exports = {"content":"_e3","container":"_e4","title":"_e5","text":"_e6","textForm":"_e7","submitButton":"_e8"};